module.exports = __webpack_public_path__ + "img/ve.3d9347e2.svg";